import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgPhoneIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.446 8a2.667 2.667 0 0 1 3.772 0l8.78 8.78a2.667 2.667 0 0 1 0 3.772l-3.742 3.743 4.336 9.758c.268.603.75 1.085 1.354 1.353l9.757 4.337L43.446 36a2.667 2.667 0 0 1 3.772 0l8.78 8.78a2.667 2.667 0 0 1 0 3.772l-6.558 6.559a5.33 5.33 0 0 1-5.67 1.213l-22.228-8.468a9.33 9.33 0 0 1-5.4-5.4L7.676 20.228a5.33 5.33 0 0 1 1.212-5.67zm1.886 1.885-6.559 6.56a2.67 2.67 0 0 0-.606 2.834l8.468 22.228a6.67 6.67 0 0 0 3.856 3.857l22.228 8.468a2.67 2.67 0 0 0 2.835-.607l6.559-6.559-8.781-8.78-3.743 3.742c-.78.78-1.96 1-2.969.552l-9.757-4.337a5.33 5.33 0 0 1-2.708-2.708l-4.336-9.757a2.67 2.67 0 0 1 .55-2.968l3.744-3.744z"
    />
  </svg>
)
export default SvgPhoneIcon
